import { render, staticRenderFns } from "./OTextarea.vue?vue&type=template&id=d1021d88&scoped=true"
import script from "./OTextarea.vue?vue&type=script&lang=js"
export * from "./OTextarea.vue?vue&type=script&lang=js"
import style0 from "./OTextarea.vue?vue&type=style&index=0&id=d1021d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1021d88",
  null
  
)

export default component.exports